__turbopack_context__.v({
  "tab": "tabItem-module-scss-module__5slara__tab",
  "tab-selected": "tabItem-module-scss-module__5slara__tab-selected",
});
